<template>
  <div>
    <v-dialog v-model="dialog.form" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 white--text light-green lighten-2">
          {{ form.user_id.length > 0 ? 'Ubah' : 'Tambah' }} Pengguna
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-form class="pt-5 pb-0">
              <p>
                Password pengguna default <b>123456</b>, anda dapat mengubahnya di menu profil general untuk masing-masing pengguna.
              </p>
              <ValidationProvider name="Nama Pengguna" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nama Pengguna"
                  prepend-inner-icon="mdi-account-circle-outline"
                  :color="style.primary"
                  v-model="form.name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Email"
                  prepend-inner-icon="mdi-email-outline"
                  :color="style.primary"
                  v-model="form.email"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Nomor Handphone" rules="required|min:10|max:13" v-slot="{ errors }">
                <v-text-field
                  type="number"
                  dense
                  outlined
                  label="Nomor Handphone"
                  prepend-inner-icon="mdi-cellphone-basic"
                  :color="style.primary"
                  v-model="form.mobilephone"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Pilih Jabatan" rules="required" v-slot="{ errors }">
                <v-select
                  dense
                  outlined
                  single-line
                  label="Pilih Jabatan"
                  :color="style.primary"
                  prepend-inner-icon="mdi-account-tie"
                  :items="role"
                  item-value="company_roles_id"
                  item-text="company_roles_label"
                  item-color="light-green lighten-2"
                  v-model="form.roles_id_arr"
                  :error-messages="errors"
                  multiple
                  chips
                  require>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>
          <v-alert 
            type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="reset(); $refs.observer.reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete" 
      persistent
      width="400">
      <v-card class="pa-5">
        <v-card-text>
          Apakah anda yakin menghapus
          <span class="font-weight-bold">
            {{ detail.user_name }}
          </span>
          ?
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            small
            color="red"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="deletes">
            <v-icon small class="mr-1">mdi-trash-can-outline</v-icon>
            Ya, hapus
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="detail = {}; dialog.delete = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-card flat min-height="800">
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0':''">
            <v-row>
              <v-col cols="12" md="5" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor') || user.user_company_roles_name.includes('administrator')"
                  :color="style.primary"
                  elevation="3"
                  class="text-capitalize white--text"
                  @click="reset()">
                  <v-icon small class="mr-1">mdi-plus</v-icon>
                  Pengguna
                </v-btn>
              </v-col>
              <v-col cols="12" md="4" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                <v-text-field
                  outlined
                  dense
                  :hide-details="true"
                  placeholder="Cari Pengguna . . ."
                  clearable
                  :color="style.primary"
                  v-model="filter.title"
                  @click:clear="filter.title = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  prepend-inner-icon="mdi-magnify">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                <v-select
                  dense
                  outlined
                  :items="[
                    {
                      label: 'Semua',
                      value: ''
                    },
                    {
                      label: 'Belum Verifikasi',
                      value: 0
                    },
                    {
                      label: 'Terverifikasi',
                      value: 1
                    }
                  ]"
                  item-text="label"
                  item-value="value"
                  item-color="light-green lighten-2"
                  v-model="filter.status"
                  v-on:change="fetch()"
                  label="Status"
                  :color="style.primary"
                  hide-details>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-4"/>
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0 py-0':'py-0'" style="min-height: 600px;">
            <v-skeleton-loader
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              type="table-tbody">
              <v-simple-table>
                <template v-slot:default>
                  <thead v-if="!process.run && list.length > 0">
                    <tr>
                      <th class="text-left pl-0">Nama Pengguna</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Nomor Handphone</th>
                      <th class="text-left">Jabatan</th>
                      <th class="text-left" v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor') || user.user_company_roles_name.includes('administrator')"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(item, index) in list" 
                      :key="index">
                      <td class="text-second pl-0">
                        <v-list-item class="pa-0">
                          <!-- <v-list-item-avatar class="rounded" size="40">
                            <v-img
                              :src="item.user_image_url">
                            </v-img>
                          </v-list-item-avatar> -->

                          <v-list-item-content>
                            <v-list-item-title class="caption font-weight-bold text-second mb-1">
                              {{ item.user_name }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </td>
                      <td class="text-second">
                        {{ item.user_email }}
                      </td>
                      <td class="text-second">
                        {{ item.user_mobilephone }}
                      </td>
                      <td class="text-second text-capitalize">
                        {{ item.user_company_roles_label_name }}
                      </td>
                      <td class="text-right pr-0" v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor') || user.user_company_roles_name.includes('administrator')">
                        <v-btn v-if="item.user_company_roles_name !== 'superuser'"
                          small
                          text
                          min-width="30"
                          class="text-capitalize green--text pa-0 mr-1"
                          @click="reset(item)">
                          <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <v-btn v-if="item.user_company_roles_name !== 'superuser'"
                          small
                          text
                          min-width="30"
                          class="text-capitalize red--text pa-0 mr-1"
                          @click="detail = item; dialog.delete = true;">
                          <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-skeleton-loader>
            <div class="d-flex align-center text-center text--secondary my-12 py-12" style="min-height: 550px;" v-if="!process.run && pagination.total_page < 1">
              <v-img 
                class="my-12"
                contain
                width="200"
                height="200"
                :src="require('../../assets/404/404.svg')">
              </v-img>
            </div>
            <v-divider/>
          </v-card-text>
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'pt-0':''">
            <v-row justify="end" align="center" v-if="pagination.total_page > 1">
              <v-col cols="12" md="2" class="d-flex align-center justify-end">
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === 1"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 mr-3"
                  @click="selected.pagination = 1">
                  <v-icon>mdi-chevron-double-left</v-icon>
                </v-btn>
                <v-btn
                  color="#263238"
                  :disabled="pagination.current < 2"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  @click="selected.pagination = selected.pagination-1">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div class="mx-5" style="width: 75px;">
                  <v-autocomplete
                    v-model="selected.pagination"
                    :items="pagination.detail"
                    color="#263238"
                    auto-select-first
                    outlined
                    dense
                    single-line
                    hide-details
                    hide-selected>
                    <template v-slot:selection="{ item }">
                      {{ item }}
                    </template>
                  </v-autocomplete>
                </div>
                <v-btn
                  color="#263238"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  :disabled="pagination.current >= pagination.total_page"
                  @click="selected.pagination = selected.pagination+1">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === pagination.total_page"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 ml-3"
                  @click="selected.pagination = pagination.total_page">
                  <v-icon>mdi-chevron-double-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  export default {
    data () {
      return {
        selected: {
          pagination: 1
        },
        dialog: {
          form: false,
          delete: false
        },
        filter: {
          title: '',
          status: ''
        },
        page: 1,
        list: [],
        pagination: {},
        detail: {},
        role: [],
        form: {
          user_id: '',
          roles_id: '',
          name: '',
          email: '',
          mobilephone: '',
          roles_id_arr: []
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'selected.pagination': function(val) {
        this.fetch(val)
      }
    },
    mounted () {
      this.fetch()
      this.roles()
    },
    methods: {
      async fetch(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 12,
          filter: [
            {
              type: 'string',
              field: 'user_name',
              value: this.filter.title,
              comparison: '<>'
            },
            {
              type: 'string',
              field: 'user_is_verified',
              value: this.filter.status
            }
          ]
        }

        await get(`auth/company/user/get-list`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          }
        })
      },
      async roles() {
        await get(`auth/company/role/get-option`)
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.role = res.data.results
          }
        })
      },
      reset(item) {
        this.dialog.form = !this.dialog.form ? true : false

        var user_company_roles = [];

        if (item !== undefined) {
          item.user_company_roles.forEach(function(object, index) {
            user_company_roles.push(object.user_company_roles_roles_id)
            //console.log(object)
          })
        }

        this.form = { 
          user_id: item !== undefined ? item.user_id : '',
          roles_id: item !== undefined ? item.user_company_roles_id : '',
          name: item !== undefined ? item.user_name : '',
          email: item !== undefined ? item.user_email : '',
          mobilephone: item !== undefined ? item.user_mobilephone : '',
          roles_id_arr: item !== undefined ? user_company_roles : [],
        }

        this.process.form = false

        this.error.message = ''
      },
      async save() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          if (this.form.user_id.length < 1) {
            this.creates()
          } else {
            this.updates()
          }
        }
      },
      async creates() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/company/user/create`, {
          data: {
            roles_id: this.form.roles_id_arr,
            name: this.form.name,
            email: this.form.email,
            mobilephone: this.form.mobilephone
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.reset()
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async updates() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/company/user/update`, {
          data: {
            user_id: this.form.user_id,
            roles_id: this.form.roles_id_arr,
            name: this.form.name,
            email: this.form.email,
            mobilephone: this.form.mobilephone
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.reset()
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async deletes() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/company/user/delete`, {
          data: {
            user_id: this.detail.user_id
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.dialog.delete = false
            this.detail = {}
            this.process.form = false
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      }
    }
  }
</script>